import Home from "./home";

export default function Login({ setIsAuth }) {
  return <Home setIsAuth={setIsAuth} />;
}
